/* eslint-disable react/destructuring-assignment */
import React, { useContext, useState } from "react";
import { string, obj, arr, bool, shape, func } from "prop-types";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import CustomData from "pages/_components/CustomData/CustomData";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import { TransactionSign } from "pages/_components/TransactionCard";

const AfipPaymentsSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { isRecipt, setShowMoreData, showMoreData, isDesktop } = props;
    const { data = {} } = transaction;
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };
    const {
        form = props?.form,
        formData = props?.formData,
        taxData = props?.taxData,
        account = props?.account,
        totalAmount = props?.totalAmount,
        taxFormData = props?.taxFormData,
    } = data;
    // let columShow;
    // let rowShow;
    // const formatColums = (i, type) => {
    //     const colum = type === "form" ? i + 2 : i + 1;
    //     const colum2 = i - 1;
    //     const colum3 = i - 4;
    //     if (colum <= 3) {
    //         columShow = colum;
    //         rowShow = 1;
    //     }
    //     if (colum >= 4 && colum <= 6) {
    //         columShow = colum2;
    //         rowShow = 2;
    //     }
    //     if (colum >= 7 && colum <= 9) {
    //         columShow = colum3;
    //         rowShow = 3;
    //     }
    // };
    return (
        <>
            {!isRecipt && (
                <GridTable>
                    <GridTable.Container className="box box-shadow" columns={3} rows={2}>
                        <GridTable.Data>
                            <CustomData
                                titleText="afip.form.label"
                                titleTextType="I18N"
                                valueText={form}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        {formData?.map((value) => (
                            // formatColums(index, "form");
                            <GridTable.Data>
                                <CustomData
                                    titleText={value?.label}
                                    titleTextType="TEXT"
                                    valueText={`${value.inputData}`}
                                    valueTextType="TEXT"
                                />
                            </GridTable.Data>
                        ))}
                        <GridTable.Data columnStart={1} columnWidth={3}>
                            <hr className="dotted data-echeck__line-horizontal-one" />
                        </GridTable.Data>
                        {taxData.length > 0 &&
                            taxData?.map((value) =>
                                // formatColums(index, "tax");
                                taxFormData?.map((dataTax) => {
                                    let returnData;
                                    if (dataTax.formCode === value.code) {
                                        returnData = (
                                            <GridTable.Data>
                                                <CustomData
                                                    titleText={value?.description}
                                                    titleTextType="TEXT"
                                                    valueText={`${dataTax.taxValue}`}
                                                    valueTextType="TEXT"
                                                />
                                            </GridTable.Data>
                                        );
                                    }
                                    return returnData;
                                }),
                            )}

                        <GridTable.Data>
                            <CustomData
                                titleText="afip.total.label"
                                titleTextType="I18N"
                                valueText={totalAmount && `$ ${totalAmount}`}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data>
                            <CustomData
                                titleText="afip.debit.account.label"
                                titleTextType="I18N"
                                valueText={account && `****${account}`}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
            )}
            {isRecipt && (
                <div className="ticket__body ">
                    <div className="ticket-header-info">
                        <CustomData
                            titleText="afip.form.label"
                            titleTextType="I18N"
                            valueText={form}
                            valueTextType="TEXT"
                        />
                        <CustomData
                            dataClass="amount tag tag-warning"
                            titleText="afip.sumary.total.amount"
                            titleTextType="I18N"
                            valueText={totalAmount && `$ ${totalAmount}`}
                            valueTextType="TEXT"
                        />
                    </div>
                    <div className="view-more-data-button" id="element-to-ignore">
                        <div className="ticket__divider inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <Button
                            aria-expanded={showMoreData ? "true" : "false"}
                            className="more-button"
                            label={buttonLabel}
                            bsStyle="link"
                            onClick={handleSeeMoreData}
                            image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                        />
                    </div>
                    <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                        {formData?.map((value) => (
                            <CustomData
                                titleText={value?.label}
                                titleTextType="TEXT"
                                valueText={`${value.inputData}`}
                                valueTextType="TEXT"
                            />
                        ))}
                        {taxData.length > 0 &&
                            taxData?.map((value) =>
                                taxFormData?.map((dataTax) => {
                                    let returnData;
                                    if (dataTax.formCode === value.code) {
                                        returnData = (
                                            <CustomData
                                                titleText={value?.description}
                                                titleTextType="TEXT"
                                                valueText={`${dataTax.taxValue}`}
                                                valueTextType="TEXT"
                                            />
                                        );
                                    }
                                    return returnData;
                                }),
                            )}
                        <GridTable.Container columns={2} rows={1}>
                            <GridTable.Data columnStart={1} rowStart={1} columnWidth={1}>
                                <CustomData
                                    titleText="afip.debit.account.label"
                                    titleTextType="I18N"
                                    valueText={account && `****${account}`}
                                    valueTextType="TEXT"
                                />
                            </GridTable.Data>
                            <GridTable.Data columnStart={2} rowStart={1} columnWidth={1}>
                                <CustomData
                                    titleText="afip.debit.operation.id.label"
                                    titleTextType="I18N"
                                    valueText={data?.afipPaymentPrepare?.operationId}
                                    valueTextType="TEXT"
                                />
                            </GridTable.Data>
                        </GridTable.Container>
                        <TransactionSign
                            noDate
                            creationTime
                            isSmall
                            hasSignatures
                            customText="afip.time.date"
                            isDesktop={isDesktop}
                            showMoreData={showMoreData}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

AfipPaymentsSummaryBody.propTypes = {
    form: string,
    formData: arr,
    taxFormData: arr,
    taxData: obj,
    account: string,
    totalAmount: shape({}),
    isRecipt: bool,
    showMoreData: bool,
    isDesktop: bool,
    setShowMoreData: func,
};

AfipPaymentsSummaryBody.defaultProps = {
    form: "",
    formData: [],
    taxFormData: [],
    taxData: {},
    account: "",
    totalAmount: {},
    isRecipt: false,
    showMoreData: false,
    isDesktop: false,
    setShowMoreData: () => {},
};

export default AfipPaymentsSummaryBody;
